import React from 'react';
import { Heading } from '@flixbus/honeycomb-react';

import styles from './upload-csv-banner.module.scss';

interface UploadCSVBannerProps {
  title: string;
  subHeader: string;
}

const UploadCSVBanner: React.FC<UploadCSVBannerProps> = ({ title, subHeader }) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleWrapper}>
        <div className={styles.icon}>
          <flix-illustration name='voucher'></flix-illustration>
        </div>
        <div className={styles.title}>
          <Heading flushSpace size={4}>
            {subHeader}
          </Heading>
          <Heading flushSpace size={1}>
            {title}
          </Heading>
        </div>
      </div>
    </div>
  );
};

export default UploadCSVBanner;
